import { Observable, of, throwError } from 'rxjs';
import { catchError, delay, switchMap, tap } from 'rxjs/operators';

import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ReLoginModalComponent } from '@app/shared/components/re-login-modal/re-login-modal.component';
import { environment } from '@env/environment';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ApiRequestHeader } from '../../models/api.models';
import { getCookieByKey, IsSignupApp, UtilitiesService } from '../utilities.service';

@Injectable()
export class HttpSessionTimeoutInterceptor implements HttpInterceptor {
  private loginModalRef?: NzModalRef<ReLoginModalComponent>;

  constructor(
    private us: UtilitiesService,
    private modal: NzModalService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!environment.production && !!localStorage.getItem('apollo-cache')) {
      const item = [].find((e) => e.url === req.url.split('v3')[1]);
      if (item)
        // local caching code. ignored for prod
        return of(
          new HttpResponse({
            url: req.url,
            status: 200,
            body: JSON.parse(item.data),
          }),
        ).pipe(delay(250));
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const skipCheck =
          !(IsSignupApp() && error.status === 401 && req.url.endsWith('users/0')) &&
          req.url.startsWith(`${location.origin}/${environment.app.resources.dashboard}`) &&
          error.status === 401;
        if (skipCheck) {
          return this._showLoginModal().pipe(
            switchMap((loggedIn: boolean) => (loggedIn ? this._continue(req, next) : this._redirect(error))),
          );
        } else return throwError(error);
      }),
    );
  }
  private _redirect(error) {
    window.forceReload = true;
    sessionStorage.setItem('adspt-redirect-after-login', location.href);
    this.us.logout();
    return throwError(error);
  }
  private _showLoginModal() {
    this.loginModalRef ||= this.modal.create({
      nzContent: ReLoginModalComponent,
      nzTitle: null,
      nzFooter: null,
      nzKeyboard: false,
      nzMaskClosable: false,
      nzClosable: false,
      nzWidth: '400px !important',
    });

    return this.loginModalRef.afterClose.pipe(
      tap(() => {
        this.loginModalRef?.destroy();
        this.loginModalRef = undefined;
      }),
    );
  }
  private _continue(req: HttpRequest<any>, next: HttpHandler) {
    if (
      req.url.startsWith(`${location.origin}/${environment.app.resources.dashboard}`) || // apollo
      req.url.indexOf('signup') !== -1 || // connect app
      req.url.indexOf('billed-usage-report') !== -1 || // billed-usage app
      (IsSignupApp() && req.url.indexOf(environment.app.resources.dashboard) !== -1) // to perform userinfo request in account signup
    ) {
      const token = getCookieByKey(IsSignupApp() && req.url.indexOf('signup') !== -1 ? 'signup-xsrf' : 'xsrf');
      if (token !== null) {
        req = req.clone({ headers: req.headers.set(ApiRequestHeader.XSRF, token) });
        if (this.us.toImpersonate()) {
          req = req.clone({
            headers: req.headers.set(ApiRequestHeader.Impersonate, this.us.toImpersonate()),
          });
        }
      }
    }
    return next.handle(req);
  }
}
